export default function ResponsiveTable() {
  const responsiveTable = document.querySelector(".responsive-table_td");
  const responsiveTableTh = document.querySelector(".responsive-table_td thead tr th");
  const responsiveTableDotButtons = document.querySelectorAll(".responsive-table_scroll-indicator");
  const columnWidth = responsiveTableTh?.offsetWidth;

  const indicatorActiveClassName = "responsive-table_scroll-indicator-active";

  document
    .querySelector("#responsive-table_scroll-button-right")
    ?.addEventListener("click", function () {
      responsiveTable &&
        responsiveTable.scroll({
          left: responsiveTable.scrollLeft + columnWidth,
          behavior: "smooth",
        });
    });

  document
    .querySelector("#responsive-table_scroll-button-left")
    ?.addEventListener("click", function () {
      responsiveTable.scroll({
        left: responsiveTable.scrollLeft - columnWidth,
        behavior: "smooth",
      });
    });

  responsiveTableDotButtons.forEach((button, i) => {
    button.addEventListener("click", () => {
      responsiveTable.scrollTo({
        left: columnWidth * i,
        behavior: "smooth",
      });
    });
  });

  const addResponsiveTableButtonsClass = () => {
    const offsetLeft = responsiveTable.scrollLeft;
    const offsetRight =
      responsiveTable.scrollWidth -
      responsiveTable.offsetWidth -
      responsiveTable.scrollLeft;

    responsiveTableDotButtons.forEach((button) => {
      button.classList.add(indicatorActiveClassName);
    });

    for (
      let i = 0, j = responsiveTableDotButtons.length - 1;
      i < responsiveTableDotButtons.length;
      i++, j--
    ) {
      if (
        offsetLeft > columnWidth * i + 10 ||
        offsetRight > columnWidth * j + 10
      ) {
        responsiveTableDotButtons[i].classList.remove(indicatorActiveClassName);
      }
    }
  };

  if (responsiveTable) {
    addResponsiveTableButtonsClass();

    responsiveTable.addEventListener("scroll", () => {
      addResponsiveTableButtonsClass();
    });
  }
}
